<div class="box">
    <div class="box__filters">
        <div class="filters__title">
            {{'device.files.select-devices' | translate}}
            <div class="dropdown dropstart cursor-pointer ms-2">
                <nb-icon icon="more-vertical-outline" size="small" id="dropdownMenu" data-bs-toggle="dropdown">
                </nb-icon>
                <div class="dropdown-menu" aria-labelledby="dropdownMenu">
                    <div class="dropdown-item" (click)="showMatchingDevices()">
                        <nb-icon icon="flip-2-outline" size="small"></nb-icon>
                        {{ 'bulk.show-matching-devices' | translate }}
                    </div>
                    <div class="dropdown-item" (click)="showAllMatchingDevices()">
                        <nb-icon icon="flip-2-outline" size="small"></nb-icon>
                        {{ 'bulk.show-all-matching-devices' | translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="filters__select">
            <div class="select__title">
                {{'common.show-below' | translate}}
            </div>
            <div class="select__button">
                <nb-select size="small" status="primary" [(selected)]="selectedMaterialId">
                    <nb-option *ngFor="let material of devices | multiPrintMaterials;trackBy: trackByFn"
                        [value]="material.id">
                        {{material.name}}
                    </nb-option>
                </nb-select>
            </div>
        </div>
    </div>

    <div class="box__devices" [nbSpinner]="loading" nbSpinnerSize="large">
        <ng-container *ngIf="devices | multiprintOnlyDevices: onlyDeviceIds
             | multiPrintDeviceStatusFilter: showDevicesWithStatus
             | multiPrintDeviceMaterialFilter: selectedMaterialId
             | multiPrintDeviceStatusSort as results">
            <div class="devices__device" *ngFor="let device of results; trackBy: trackByFn ">
                <app-multiprint-device [data]="device" [uploadId]="device?.uploadId"
                    (click)="device.statusCode === statusTypes.idle && !isPrintingState && toggleSelectDevice(device)">
                </app-multiprint-device>
            </div>
            <div *ngIf="results?.length === 0" class="box__devices--empty">
                {{'bulk.no-devices-found' | translate}}
            </div>
        </ng-container>
    </div>

    <div class="box__confirmation">
        <ng-container *ngIf="!isPrintingState; else printingState">            
            <div class="confirmation__container" *ngIf="differenceInMaterials || emptyMaterial || chamberTemperatureNotStabilized">
                    <div class="confirmation__container__checkbox" (click)="confirmPrint(!forcePrinting)">
                        <nb-checkbox [checked]="forcePrinting" status="basic" (checkedChange)="confirmPrint($event)">
                        </nb-checkbox>
                    </div>
                    <div class="confirmation__container__text" (click)="confirmPrint(!forcePrinting)">
                        {{ 'common.warning' | translate }}!
                        <ng-container *ngIf="differenceInMaterials">
                            {{ 'bulk.warning-force-print' | translate }}
                        </ng-container>
                
                        <ng-container *ngIf="chamberTemperatureNotStabilized">
                            {{ 'bulk.warning-chamber-temperature-not-stabilized' | translate }}
                        </ng-container>

                        {{'bulk.confirm-force-print' | translate}}
                    </div>
            </div>
            <div class="confirmation__button">
                <button nbButton [status]="'primary'" [size]="'small'" [disabled]="!printIsPossible"
                    (click)="startMultiPrint()" tabindex="-1">
                    {{ 'device.buttons.print' | translate }}
                </button>
            </div>
        </ng-container>
        <ng-template #printingState>
            <div class="confirmation__button">
                <button nbButton [status]="'danger'" [size]="'small'" tabindex="-1" (click)="stopMultiPrint()" [disabled]="disableStopButton">
                    <nb-icon icon="stop-circle-outline"></nb-icon>
                    {{ 'device.buttons.stop' | translate }}
                </button>
            </div>
        </ng-template>
    </div>
</div>